import ApiService from '@/services/core/api.service'

const PasswordResetService = {
  async put (payload) {
    return ApiService.put(`user/reset-password/${payload.id}`, payload)
  }
}

export default PasswordResetService
